<template>
  <i
    :class="[appIcons[props.name], 'inline-block', 'shrink-0', sizeMap[props.size]]"
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
  import { appIcons, type AppIconName } from "../../../../types/icons";

  const props = withDefaults(
    defineProps<{
      name: AppIconName;
      size?: "xs" | "sm" | "md" | "lg" | "xl";
    }>(),
    { size: "md" },
  );

  const sizeMap = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8",
  } as const;
</script>
